import {useLoginContext, useUserContext} from '@hconnect/login'
import {Loading} from '@hm/fundamental'
import {PLANT_HIERARCHY_QUERY_KEY} from '@hproduce/suite-core'
import {useQueryClient} from '@tanstack/react-query'
import React, {useEffect} from 'react'
import {Outlet} from 'react-router'

import {getFeaturesMenu, getPlantHierarchy} from '../api/endpoints'

import {LoginPage} from './LoginPage'

export const LoginGuard: React.FC = () => {
  const {isLoggedIn} = useLoginContext()
  const {loggedUser} = useUserContext()
  const queryClient = useQueryClient()

  const isUserReady = isLoggedIn && Boolean(loggedUser)

  // Kick off the independent bootstrap queries in parallel as soon as the user is
  // known, instead of letting them run serially through the guard chain
  // (features menu -> plant hierarchy).
  useEffect(() => {
    if (!isUserReady) {
      return
    }

    void queryClient.prefetchQuery({
      queryKey: ['featuresMenu'],
      queryFn: async () => (await getFeaturesMenu()).data
    })
    void queryClient.prefetchQuery({
      queryKey: [PLANT_HIERARCHY_QUERY_KEY],
      queryFn: async () => (await getPlantHierarchy()).data
    })
  }, [isUserReady, queryClient])

  if (!isLoggedIn) {
    return <LoginPage />
  }

  if (!loggedUser) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="xlarge" data-cy="page_loader" />
      </div>
    )
  }

  return <Outlet />
}
